module.exports = __webpack_public_path__ + "img/discharge.3ab84541.svg";